const scrollIntoView = (element) => {
    // In order to support Element ScrollIntoView functionality this function created
    // if window.scrollIntoView is not available then execute this code
    if (!window.scrollIntoView) {
        (function () {
            function e(t, n, r) {
                function s(o, u) {
                    if (!n[o]) {
                        if (!t[o]) {
                            const a = typeof require === 'function' && require;
                            if (!u && a) return a(o, !0);
                            if (i) return i(o, !0);
                            const f = new Error(`Cannot find module '${o}'`);
                            throw ((f.code = 'MODULE_NOT_FOUND'), f);
                        }
                        const l = (n[o] = { exports: {} });
                        t[o][0].call(
                            l.exports,
                            (e) => {
                                const n = t[o][1][e];
                                return s(n || e);
                            },
                            l,
                            l.exports,
                            e,
                            t,
                            n,
                            r
                        );
                    }
                    return n[o].exports;
                }
                var i = typeof require === 'function' && require;
                for (let o = 0; o < r.length; o++) s(r[o]);
                return s;
            }
            return e;
        })()(
            {
                1: [
                    function (require, module, exports) {
                        const COMPLETE = 'complete';
                        const CANCELED = 'canceled';
                        function raf(e) {
                            if ('requestAnimationFrame' in window)
                                return window.requestAnimationFrame(e);
                            setTimeout(e, 16);
                        }
                        function setElementScroll(e, t, n) {
                            e.self === e
                                ? e.scrollTo(t, n)
                                : ((e.scrollLeft = t), (e.scrollTop = n));
                        }
                        function getTargetScrollLocation(e, t, n) {
                            let l;
                            let i;
                            let r;
                            let a;
                            let o;
                            let s;
                            let f;
                            const c = e.getBoundingClientRect();
                            const u = n && n.left != null ? n.left : 0.5;
                            const d = n && n.top != null ? n.top : 0.5;
                            const m = n && n.leftOffset != null ? n.leftOffset : 0;
                            const g = n && n.topOffset != null ? n.topOffset : 0;
                            const h = u;
                            const p = d;
                            if (t.self === t)
                                (s = Math.min(c.width, t.innerWidth)),
                                    (f = Math.min(c.height, t.innerHeight)),
                                    (i = c.left + t.pageXOffset - t.innerWidth * h + s * h),
                                    (r = c.top + t.pageYOffset - t.innerHeight * p + f * p),
                                    (r -= g),
                                    (a = (i -= m) - t.pageXOffset),
                                    (o = r - t.pageYOffset);
                            else {
                                (s = c.width), (f = c.height), (l = t.getBoundingClientRect());
                                const E = c.left - (l.left - t.scrollLeft);
                                const S = c.top - (l.top - t.scrollTop);
                                (i = E + s * h - t.clientWidth * h),
                                    (r = S + f * p - t.clientHeight * p),
                                    (i = Math.max(
                                        Math.min(i, t.scrollWidth - t.clientWidth),
                                        0
                                    )),
                                    (r = Math.max(
                                        Math.min(r, t.scrollHeight - t.clientHeight),
                                        0
                                    )),
                                    (r -= g),
                                    (a = (i -= m) - t.scrollLeft),
                                    (o = r - t.scrollTop);
                            }
                            return { x: i, y: r, differenceX: a, differenceY: o };
                        }
                        function animate(e) {
                            const t = e._scrollSettings;
                            if (t) {
                                const n = getTargetScrollLocation(t.target, e, t.align);
                                const l = Date.now() - t.startTime;
                                const i = Math.min((1 / t.time) * l, 1);
                                if (l > t.time && t.endIterations > 3)
                                    return (
                                        setElementScroll(e, n.x, n.y),
                                        (e._scrollSettings = null),
                                        t.end(COMPLETE)
                                    );
                                t.endIterations++;
                                const r = 1 - t.ease(i);
                                if ((setElementScroll(
                                    e,
                                    n.x - n.differenceX * r,
                                    n.y - n.differenceY * r
                                ),
                                    l >= t.time))
                                    return animate(e);
                                raf(animate.bind(null, e));
                            }
                        }
                        function transitionScrollTo(e, t, n, l) {
                            let i;
                            const r = !t._scrollSettings;
                            const a = t._scrollSettings;
                            const o = Date.now();
                            function s(e) {
                                (t._scrollSettings = null),
                                    t.parentElement &&
                                    t.parentElement._scrollSettings &&
                                    t.parentElement._scrollSettings.end(e),
                                    l(e),
                                    t.removeEventListener('touchstart', i, { passive: !0 });
                            }
                            a && a.end(CANCELED),
                                (t._scrollSettings = {
                                    startTime: a ? a.startTime : Date.now(),
                                    endIterations: 0,
                                    target: e,
                                    time: n.time + (a ? o - a.startTime : 0),
                                    ease: n.ease,
                                    align: n.align,
                                    end: s
                                }),
                                (i = s.bind(null, CANCELED)),
                                t.addEventListener('touchstart', i, { passive: !0 }),
                                r && animate(t);
                        }
                        function defaultIsScrollable(e) {
                            return (
                                'pageXOffset' in e ||
                                ((e.scrollHeight !== e.clientHeight ||
                                    e.scrollWidth !== e.clientWidth) &&
                                    getComputedStyle(e).overflow !== 'hidden')
                            );
                        }
                        function defaultValidTarget() {
                            return !0;
                        }
                        module.exports = function (e, t, n) {
                            if (e) {
                                typeof t === 'function' && ((n = t), (t = null)),
                                    t || (t = {}),
                                    (t.time = isNaN(t.time) ? 1000 : t.time),
                                    (t.ease =
                                        t.ease ||
                                        function (e) {
                                            return 1 - (1 - e) ** (e / 2);
                                        });
                                for (var l = e.parentElement, i = 0, r = t.validTarget || defaultValidTarget, a = t.isScrollable; l;) {
                                    if ((r(l, i) &&
                                        (a
                                            ? a(l, defaultIsScrollable)
                                            : defaultIsScrollable(l)) &&
                                        (i++, transitionScrollTo(e, l, t, o)),
                                        !(l = l.parentElement)))
                                        return;
                                    l.tagName === 'BODY' &&
                                        (l =
                                            (l = l.ownerDocument).defaultView || l.ownerWindow);
                                }
                            }
                            function o(e) {
                                --i || (n && n(e));
                            }
                        };
                    },
                    {}
                ],
                2: [
                    function (require, module, exports) {
                        window.scrollIntoView = require('./scrollIntoView');
                    },
                    { './scrollIntoView': 1 }
                ]
            },
            {},
            [2]
        );
    }
    // scroll the requested element into View
    window.scrollIntoView(element);
};
export default scrollIntoView;
